import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { Haptics, ImpactStyle } from "@capacitor/haptics";

export const isNativePlatform = () => Capacitor.isNativePlatform();
export const getPlatform = () => Capacitor.getPlatform();

// Route /api requests to active backend on native platform
if (typeof window !== "undefined" && Capacitor.isNativePlatform()) {
  const originalFetch = window.fetch;
  const SERVER_HOST = "https://rotterdamaurahair.com";
  window.fetch = function (input, init) {
    if (typeof input === "string" && input.startsWith("/api/")) {
      input = SERVER_HOST + input;
    }
    return originalFetch(input, init);
  };
}

/**
 * Initialize Android Status Bar, Splash Screen & Native Styling
 */
export async function initNativeApp() {
  if (!isNativePlatform()) return;

  try {
    // 1. Configure Status Bar
    await StatusBar.setStyle({ style: Style.Dark });
    if (Capacitor.getPlatform() === "android") {
      await StatusBar.setBackgroundColor({ color: "#020617" });
      await StatusBar.setOverlaysWebView({ overlay: false });
    }
  } catch (e) {
    console.warn("StatusBar init warning:", e);
  }

  try {
    // 2. Hide Splash Screen smoothly
    setTimeout(async () => {
      try {
        await SplashScreen.hide();
      } catch (e) {}
    }, 600);
  } catch (e) {
    console.warn("SplashScreen init warning:", e);
  }
}

/**
 * Trigger light haptic feedback on Android touch
 */
export async function triggerHapticTap() {
  if (!isNativePlatform()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch (e) {}
}

/**
 * Trigger success haptic notification on Android
 */
export async function triggerHapticSuccess() {
  if (!isNativePlatform()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch (e) {}
}

/**
 * Setup Android Hardware Back Button listener
 */
export function setupAndroidBackButton(closeModalCallback) {
  if (!isNativePlatform()) return () => {};

  const listenerPromise = App.addListener("backButton", ({ canGoBack }) => {
    if (closeModalCallback && closeModalCallback()) {
      // Handled by closing active modal
      return;
    }
    if (canGoBack) {
      window.history.back();
    } else {
      App.exitApp();
    }
  });

  return () => {
    listenerPromise.then(l => l.remove()).catch(() => {});
  };
}

/**
 * Setup Deep Link listener (e.g. aurahair://payment-success?id=APT-123)
 */
export function setupDeepLinkListener(onDeepLink) {
  if (!isNativePlatform()) return () => {};

  const listenerPromise = App.addListener("appUrlOpen", (data) => {
    console.log("[Native DeepLink] Received URL:", data.url);
    if (data.url && onDeepLink) {
      onDeepLink(data.url);
    }
  });

  return () => {
    listenerPromise.then(l => l.remove()).catch(() => {});
  };
}